import { useMutation } from '@tanstack/react-query';
import useUser from '../global/useUser';
import {
  invalidateGiftCardsPage,
  applyGiftCardCode,
} from '../../services/gift-cards';
import { updateCustomerBeforePayment } from '../../services/payments';
import { CheckoutCustomer } from '../../types/payments';

function useApplyGiftCardCode({
  onSuccess,
  onError,
}: {
  onSuccess?: () => void | Promise<void>;
  onError?: (error: Error) => void;
} = {}) {
  const { user } = useUser();

  return useMutation({
    mutationFn: async ({
      code,
      customer,
    }: {
      code: string;
      customer: CheckoutCustomer;
    }) => {
      if (!user?.business?.id) {
        throw new Error('Business ID is required');
      }

      const customerId = await updateCustomerBeforePayment(customer);
      if (!customerId) {
        throw new Error('Failed to create customer');
      }

      return applyGiftCardCode({
        businessId: user.business.id,
        code,
        customerId,
      });
    },
    onSuccess: async () => {
      // Invalidate gift card balance queries to refresh the balance
      invalidateGiftCardsPage('invalidate');
      await onSuccess?.();
    },
    onError: (error: Error) => {
      onError?.(error);
    },
  });
}

export default useApplyGiftCardCode;
